import ButtonSimple from './ButtonSimple';

export default class ButtonSimpleVO extends ButtonSimple {
  constructor({ game, x = 0, y = 0, up, over, atlas = 'ui_buttons', voID, voSpriteID = 'vo_ui' }) {
    super({ game, x, y, up, over, atlas });
    this.voID = voID;
    this.voSpriteID = voSpriteID;

    this.canPlayVO = true;
  }

  onOver() {
    this.isOver = true;
    this.scale.set(1.1);

    if (this.canPlayVO) {
      this.game.sounds.playVO(this.voID, {
        spriteID: this.voSpriteID,
      });
      this.game.springRollCaptionsPlugin.playCaption(this.voID);
    }
  }
}
